import { StreamVideoClient } from "@stream-io/video-react-sdk";

// Stream mints the token for a specific user id — always connect as that identity.
export function streamTokenUserId(token) {
  try {
    return JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")))?.user_id || null;
  } catch {
    return null;
  }
}

// `getOrCreateInstance` hands every consumer (1:1 call, Room stage, StrictMode double-mount) the SAME
// client per apiKey+user, so one consumer's `disconnectUser()` would drop the others mid-call.
// Ref-count holders and only disconnect when the last one releases.
const holds = new Map();

export function acquireStreamClient({ apiKey, token, user }) {
  const client = StreamVideoClient.getOrCreateInstance({ apiKey, token, user });
  holds.set(client, (holds.get(client) || 0) + 1);
  return client;
}

export async function releaseStreamClient(client) {
  if (!client) return;
  const left = (holds.get(client) || 1) - 1;
  if (left > 0) {
    holds.set(client, left);
    return;
  }
  holds.delete(client);
  await client.disconnectUser().catch(() => {});
}
